import {Dispatch} from 'redux';

import Types from '../Types';

import AppState from '../../reducers/AppState';

import indexGenerics, {Params as BaseParams} from '../generics/index';

import ActorCostume from '../../../domain/entities/ActorCostume';
import PaginatedResult from '../../../domain/results/PaginatedResult';

import NetActorCostumesRepository from '../../../data/repositories/writer/NetActorCostumesRepository';

const types = {
  failure: Types.IndexActorCostumesFailure,
  request: Types.IndexActorCostumesRequest,
  success: Types.IndexActorCostumesSuccess,
};

export interface Params extends BaseParams {
  actorId: number;
  actorAccessorySetId?: number;
  actorHairStyleId?: number;
}

export default function action(
  params: Params,
): (
  dispatch: Dispatch<any>,
  getState: () => AppState,
) => Promise<PaginatedResult<ActorCostume>> {
  return indexGenerics(new NetActorCostumesRepository(), types, params);
}
